import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { GlobalService } from 'src/app/services/global.service';

import { Customer } from 'src/app/domain/Customer';

@Component({
  selector: 'app-glovo-bags-master',
  templateUrl: './glovo-bags-master.component.html',
  styleUrls: ['./glovo-bags-master.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
  ],
})
export class GlovoBagsMasterComponent implements OnInit {
  private readonly globalService = inject(GlobalService);

  @Input() customer: Customer;
  link: string;

  ngOnInit(): void {
    this.link = this.globalService.translateUrl('recover-password');
  }
}
